// 結果の読み（カタカナ）を、韻が一致したモーラだけ強調して表示する。
// 一致範囲 [matchStart, matchEnd) は search.worker が返すモーラ index。
// missMorae = ゆるマッチで不一致だったモーラ（範囲内だが「踏めていない」箇所）。減光して区別する。
// フォントサイズは親から継承する（本文でも ruby の rt 内でも使う）。

import { useMemo } from 'react'
import { toMorae } from '../core/vowel'

interface Props {
  reading: string
  matchStart: number
  matchEnd: number
  missMorae?: number[]
  /** 文字色トーン。'proper' = 固有名詞（青字）。ハイライト背景・太字・miss 減光は共通。 */
  tone?: 'default' | 'proper'
}

export function VowelHighlight({ reading, matchStart, matchEnd, missMorae, tone = 'default' }: Props) {
  const morae = useMemo(() => toMorae(reading), [reading])
  const missSet = useMemo(() => new Set(missMorae ?? []), [missMorae])
  const onColor = tone === 'proper' ? 'text-proper' : 'text-ink'
  const offColor = tone === 'proper' ? 'text-proper/70' : 'text-mut'
  return (
    <span className="tracking-wide">
      {morae.map((m, i) => {
        const on = i >= matchStart && i < matchEnd
        const miss = on && missSet.has(i)
        return (
          <span
            key={i}
            data-match={miss ? 'miss' : on ? 'on' : 'off'}
            className={
              miss
                ? 'rounded-[3px] text-miss underline decoration-miss decoration-dashed decoration-2 underline-offset-2'
                : on
                  ? `rounded-[3px] bg-gradient-to-r from-hl-from to-hl-to font-bold ${onColor}`
                  : offColor
            }
          >
            {m.k}
          </span>
        )
      })}
    </span>
  )
}
